export default "__VITE_ASSET__2Fce1oh7__"